<template lang="pug">

  v-select.select--stock-dropdown(
    :options="stockOptions", 
    label="text", 
    v-model="selectedStock", 
    :placeholder="placeholder", 
    @input="STOCK_SELECTED",
    :components="{Deselect}"
  )

</template>



<script>
import { mapGetters, mapActions } from 'vuex';

import vSelect from 'vue-select'

export default {
  props: {
    dropdownColWidth: {
      type: Number,
      default: 10,
    },
    buttonColWidth: {
      type: Number,
      default: 2,
    },
    defaultCounterCode: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Please type the counter\'s code or name and press enter to select',
    }
  },

  name: 'SelectSingleStock',

  mixins: [],

  components: {
    vSelect
  },

  data() {
    return {
      selectedStock: null,
      Deselect: {
        render: createElement => createElement('span', 'Clear'),
      },
      OpenIndicator: {
        render: createElement => createElement('span', 'V'),
      },
    }
  },

  computed: { 
    ...mapGetters('stock', {
      stockOptions: 'dropdownOptions'
    }),
    
    stockCode() {
      if(this.selectedStock === null || Object.keys(this.selectedStock).length === 0 || !this.selectedStock) {
        return null;
      }

      return this.selectedStock.value;
    }
  },

  methods: {
    ...mapActions('stock', [
      'setCurrentStock'
    ]),
    RESET() {
      this.selectedStock = null; 
    },

    // Method to run everytime stock is selected / updated
    // Set current stock code in vuex
    // Emit 'stockSelected' event (Parent component will handle the change)
    STOCK_SELECTED() {
      if(this.stockCode == null) {
        this.setCurrentStock(null);
      }
      this.$emit('stockSelected', this.stockCode);
    },

    // Set the stock selected 
    SET_STOCK_SELECTION(code) {
      if(!code) {
        return;
      }

      let _currentStock = this.stockOptions.find(stock => stock.value === code);

      if(_currentStock) {
        this.selectedStock = _currentStock;
      }
    },
  },

  watch: {
    stockOptions() {
      this.SET_STOCK_SELECTION(this.defaultCounterCode);
    },

    defaultCounterCode() {
      this.SET_STOCK_SELECTION(this.defaultCounterCode);
    }
  },

  created() {
    this.SET_STOCK_SELECTION(this.defaultCounterCode);
  },
}
</script>




<style lang="scss">
  @import "vue-select/src/scss/vue-select.scss";

  .vs__actions {
  }

  .vs__clear {
    span {
      background: $color-body-bg;
      color: $color-primary;
      padding: 4px 8px;
      border-radius: 2px;
      margin-right: 8px;
      font-size: 12px;
      text-transform: uppercase;
      white-space: nowrap;
      letter-spacing: 0.5px;
    }
  }

  .vs__search {
    @include primaryFont600;

    &::placeholder {
      color: $color-body-text;
      @include primaryFont500;
    }

    &:-ms-input-placeholder {
      color: $color-body-text;
      @include primaryFont500;
    }

    &::-ms-input-placeholder {
      color: $color-body-text;
      @include primaryFont500;
    }
  }

  .vs__selected {
    @include primaryFont600;
    color: $color-secondary;

    .vs--open & {
      color: $color-body-text;
    }
  }

  .vs__open-indicator {
    margin-right: 10px;
    cursor: pointer;
    color: $color-secondary;
    -webkit-transform: scale(0.8);
    transform: scale(0.8);

    .vs--open & {
      -webkit-transform: scale(0.8) rotate(180deg);
      transform: scale(0.8) rotate(180deg);
    }
  }
</style>
